import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NbButtonModule } from '@nebular/theme';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyAutocompleteComponent } from './formly-autocomplete.component';

export const FormFieldAutocomplete = 'autocomplete';

@NgModule({
  declarations: [FormlyAutocompleteComponent],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: FormFieldAutocomplete,
          component: FormlyAutocompleteComponent,
          wrappers: ['form-field'],
        },
      ],
    }),
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    NbButtonModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class FormFieldsAutocompleteModule {}
